import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-charcoal-900 py-8 md:py-10 border-t border-charcoal-800" data-id="element-32">
        <div className="container mx-auto px-4 text-center" data-id="element-33">
          <p className="font-serif text-amber-400 text-xl mb-4" data-id="element-34">Anti-Roomies</p>
          <p className="text-cream-200/40 text-sm mb-8" data-id="element-35">
            Recuperando la conexión en parejas reales.
          </p>
          <div className="flex justify-center gap-6 text-xs text-cream-200/30" data-id="element-36">
            <button onClick={() => setTermsOpen(true)} className="hover:text-cream-200/60 transition-colors" data-id="element-37">
              Términos de Servicio
            </button>
            <button onClick={() => setPrivacyOpen(true)} className="hover:text-cream-200/60 transition-colors" data-id="element-38">
              Política de Privacidad
            </button>
          </div>
          <p className="mt-8 text-[10px] text-cream-200/20" data-id="element-39">
            © {new Date().getFullYear()} Anti-Roomies. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-40">
        <div className="space-y-6" data-id="element-41">
          <section data-id="element-42">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-43">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-44">
              Recopilamos información personal que nos proporcionas directamente
              al realizar una compra, incluyendo tu nombre, dirección de correo
              electrónico y datos de pago. Esta información es necesaria para
              procesar tu pedido y entregarte el producto digital.
            </p>
          </section>

          <section data-id="element-45">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-46">
              2. Uso de la Información
            </h3>
            <p data-id="element-47">Utilizamos tu información personal para:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-cream-200/70" data-id="element-48">
              <li data-id="element-49">Procesar y completar tu compra</li>
              <li data-id="element-50">Enviarte el producto digital adquirido</li>
              <li data-id="element-51">Comunicarnos contigo sobre tu pedido</li>
              <li data-id="element-52">Enviarte actualizaciones del producto (si aplica)</li>
            </ul>
          </section>

          <section data-id="element-53">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-54">
              3. Protección de Datos
            </h3>
            <p data-id="element-55">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal contra acceso no autorizado,
              pérdida o alteración. Los pagos son procesados de forma segura a
              través de proveedores de pago certificados.
            </p>
          </section>

          <section data-id="element-56">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-57">
              4. Compartir Información
            </h3>
            <p data-id="element-58">
              No vendemos, alquilamos ni compartimos tu información personal con
              terceros, excepto cuando sea necesario para procesar tu pago o
              cuando la ley lo requiera.
            </p>
          </section>

          <section data-id="element-59">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-60">5. Cookies</h3>
            <p data-id="element-61">
              Utilizamos cookies esenciales para el funcionamiento del sitio web
              y cookies analíticas para entender cómo los visitantes interactúan
              con nuestro sitio. Puedes configurar tu navegador para rechazar
              cookies.
            </p>
          </section>

          <section data-id="element-62">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-63">6. Tus Derechos</h3>
            <p data-id="element-64">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. También puedes solicitar una copia de los datos que
              tenemos sobre ti.
            </p>
          </section>

          <section data-id="element-65">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-66">
              7. Cambios a esta Política
            </h3>
            <p data-id="element-67">
              Podemos actualizar esta política de privacidad ocasionalmente. Te
              notificaremos sobre cambios significativos publicando la nueva
              política en esta página.
            </p>
          </section>

          <p className="text-cream-200/50 text-xs pt-4 border-t border-charcoal-700" data-id="element-68">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            month: 'long',
            year: 'numeric'
          })}
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos de Servicio" data-id="element-69">
        <div className="space-y-6" data-id="element-70">
          <section data-id="element-71">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-72">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-73">
              Al acceder y utilizar este sitio web y realizar una compra,
              aceptas estar sujeto a estos términos de servicio. Si no estás de
              acuerdo con alguna parte de estos términos, no debes utilizar
              nuestro sitio.
            </p>
          </section>

          <section data-id="element-74">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-75">
              2. Descripción del Producto
            </h3>
            <p data-id="element-76">
              Anti-Roomies es un producto digital (ebook) que incluye guías,
              ejercicios y materiales descargables diseñados para ayudar a
              parejas a reconectar. El producto se entrega en formato digital
              inmediatamente después de la compra.
            </p>
          </section>

          <section data-id="element-77">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-78">
              3. Uso del Producto
            </h3>
            <p data-id="element-79">
              El producto es para uso personal únicamente. No está permitido:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1 text-cream-200/70" data-id="element-80">
              <li data-id="element-81">Redistribuir, revender o compartir el contenido</li>
              <li data-id="element-82">Modificar o crear obras derivadas</li>
              <li data-id="element-83">Utilizar el contenido con fines comerciales</li>
              <li data-id="element-84">Compartir tu acceso con terceros</li>
            </ul>
          </section>

          <section data-id="element-85">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-86">
              4. Política de Reembolso
            </h3>
            <p data-id="element-87">
              Debido a la naturaleza digital del producto, todas las ventas son
              finales. Sin embargo, si experimentas problemas técnicos para
              acceder al contenido, trabajaremos contigo para resolver el
              problema.
            </p>
          </section>

          <section data-id="element-88">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-89">
              5. Descargo de Responsabilidad
            </h3>
            <p data-id="element-90">
              Anti-Roomies es un recurso educativo y no sustituye la terapia
              profesional de pareja o atención de salud mental. Los resultados
              pueden variar según cada pareja. No garantizamos resultados
              específicos.
            </p>
          </section>

          <section data-id="element-91">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-92">
              6. Propiedad Intelectual
            </h3>
            <p data-id="element-93">
              Todo el contenido, incluyendo textos, gráficos, logos y materiales
              descargables, está protegido por derechos de autor y es propiedad
              exclusiva de Anti-Roomies.
            </p>
          </section>

          <section data-id="element-94">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-95">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-96">
              En ningún caso seremos responsables por daños indirectos,
              incidentales o consecuentes que resulten del uso o la
              imposibilidad de usar nuestro producto o servicios.
            </p>
          </section>

          <section data-id="element-97">
            <h3 className="text-amber-400 font-medium mb-2" data-id="element-98">
              8. Modificaciones
            </h3>
            <p data-id="element-99">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación en el sitio web.
            </p>
          </section>

          <p className="text-cream-200/50 text-xs pt-4 border-t border-charcoal-700" data-id="element-100">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            month: 'long',
            year: 'numeric'
          })}
          </p>
        </div>
      </Modal>
    </>;
}